import Publishers from "./routes/publishers/Publishers.tsx";
import MyPublisher from "./routes/my-publisher/MyPublisher.tsx";
import AresUpdates from "./routes/ares-updates/AresUpdates.tsx";
import PublisherRegistrations from "./routes/publisher-registrations/PublisherRegistration.tsx";
import PublisherUpdates from "./routes/publisher-updates/PublisherUpdates.tsx";
import AdminPage from "./routes/admin/AdminPage.tsx";
import ImportPublishers from "./routes/import/ImportPublishers.tsx";
import { RoleEnum } from "./types/RoleEnum.ts";

export const routesConfig = {
  aresUpdates: {
    path: "/ares-updates",
    component: AresUpdates,
    roles: [RoleEnum.AGENCY_WORKER],
  },
  publisherRegistrations: {
    path: "/publisher-registrations",
    component: PublisherRegistrations,
    roles: [RoleEnum.AGENCY_WORKER],
  },
  publisherUpdates: {
    path: "/publisher-updates",
    component: PublisherUpdates,
    roles: [RoleEnum.AGENCY_WORKER],
  },
  publishers: {
    path: "/publishers",
    component: Publishers,
    roles: [RoleEnum.AGENCY_WORKER],
  },
  myPublisher: {
    path: "/my-publisher",
    component: MyPublisher,
    roles: [RoleEnum.PUBLISHER_ADMIN, RoleEnum.PUBLISHER_GUARANTOR],
  },
  adminEnvironmentVariables: {
    path: "/admin/environment-variables",
    component: AdminPage,
    roles: [RoleEnum.SUPERUSER],
  },
  dataImport: {
    path: "/data-import",
    component: ImportPublishers,
    roles: [RoleEnum.SUPERUSER],
  },
};
